import { render, staticRenderFns } from "./FilterBookmarks.vue?vue&type=template&id=698af82c"
import script from "./FilterBookmarks.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilterBookmarks.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports